<template>
  <v-card
    class="mx-auto"
    :width="width"
    style="border-radius: 10px;"
    :elevation="3"
    :style="{ opacity:  data.old ? 0.4 : 1 }"
  >
    <div :style="{ backgroundColor: data.color }">
    <v-img
      :src="image"
      aspect-ratio="16/9"
      cover
      :style="{ height: smallCard ? '116px' : null }"
      style="width: 100%;border-radius: 10px 10px 0 0;"
    >
      <p style="z-index:100;margin: 0px 0 0 0;position:sticky; color:white;margin: 10px; font-size: 15px;">
        <b>{{ data.place ? getTranslation(data.place, locale) : data.categoryID ? getTranslation(data.tag, locale) : '' }}</b>
      </p>
    </v-img>
    </div>

    <v-card-title 
      color="red"
      :style="{ color: activityColor1 ? activityColor1 : color1 }"
    >
      <div class="time" :style="{ top: smallCard ? '103px' : `${180}px`, backgroundColor: `${data.timeColor} !important`, color: contentTypeID === 'pro' ? 'black' : 'white' }">
        <v-icon class="time-icon" dark
          :style="{ color: contentTypeID !== 'pro' ? '#FFFFFF' : '#000000' }" 
          style="font-size:1rem;"
        >mdi-clock-time-five-outline</v-icon><span 
          style="font-size:1.1rem;font-weight:700;"
        >{{ data.allTimes ? getTranslation({ es: 'Todo el d�a', en: 'All day'}, locale) : time }}</span>
      </div>
      <p style="margin-top: 5px;margin-bottom: 0;"><span style="font-weight: 300;">{{ getTranslation(title, 'es') }}</span></p>
    </v-card-title>

    <v-card-subtitle>
      <table border="0" width="100%">
        <tr>
          <td width="50%">
            <small>Adultos: </small><b>{{data.adults}}</b>
          </td>
          <td width="50%">
            <small>Ni�os: </small><b>{{data.children}}</b>
          </td>
        </tr>
      </table>

      <!--p style="margin:0;">
        <small>Adultos: </small><b>{{data.adults}}</b>
      </p>
      <p style="margin:0;">
        <small>Ni�os: </small><b>{{data.children}}</b>
      </p-->
    </v-card-subtitle>
  </v-card>
</template>

<script>
export default {
  name: 'Event',
  props: {
    contentTypeID: {
      type: String,
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
    color1: {
      type: String,
      default: '#1a1a1a'
    },
    color2: {
      type: String,
      default: '#cc2526'
    },
    locale: {
      type: String,
      default: 'es'
    },
  },
  data () {
    return {
      image: null,
      time: null,
      title: null,
      subtitle: null,
      active: false,
      width: 285,
      height: 132,
      activityColor1: null,
      activityColor2: null,
    }
  },
  computed: {
    smallCard () {
      return true//116
    },
  },
  watch: {
    'data.image' () { 
      this.prepareData()
    },
    'data.time' () { 
      this.prepareData()
    },
    'data.title' () { 
      this.prepareData()
    },
    'data.subtitle' () { 
      this.prepareData()
    },
    'data.detail' () { 
      this.prepareData()
    },
    'data.active' () { 
      this.prepareData()
    },
    'data.color1' () { 
      this.prepareData()
    },
    'data.color2' () { 
      this.prepareData()
    },
  },
  mounted () {
    this.prepareData()
  },
  methods: {
    getTranslation (v, locale) {
      if (!v) return ''
      if (v[locale]) return v[locale]
      if (v['es']) return v['es']
      return v[0]
    },
    prepareData () {
      this.image = this.data.image
      this.time = this.data.time
      this.title = this.data.title
      this.detail = this.data.detail
      this.subtitle = this.data.subtitle
      this.active = this.data.active ? true : false
      this.activityColor1 = this.data.color1
      this.activityColor2 = this.data.color2
    },
  },
}
</script>

<style scoped>
.time {
  position: absolute;
  height: 25px;
  margin-left: -16px;
  width: 180px;
  border-radius: 0 30px 30px 0;
  padding: 0 0 0 35px;
  font-size: 0.8rem !important;
  color: white;
  line-height: 24px;
  background-color: black;
}
.time span {
  font-size: 14px;
}
.time-icon {
  margin-right: 6px;
  color: white;
  margin-top: -4px !important;
}
.v-card-title {
  font-size: 16px;
  min-height: 30px;
  line-height: 1;
  padding: 22px 0 0 15px !important;
}
.v-card-subtitle {
  font-size: 10px;
  line-height: 1;
  padding: 0 0 20px 15px !important;
}
</style>


